<template>
  <div class="motor-configurator" :class="device">
    <button class="view-cart-button" @click="setCartState" v-if="!isMagento">
      {{ $t('cart.button_text') }}
    </button>

    <transition name="fade" mode="out-in">
      <div class="cart-dropdown"
           v-if="isCartOpen"
           :class="{'active': isCartOpen}">
        <order-cart @close="setCartState"></order-cart>
      </div>
    </transition>

    <motor-decision-aid
      @close="$store.commit('preference/openAid', {type: null})"
      v-if="openModal.type"
      :type="openModal.type"
      :tab="openModal.tab"
      :subtype="openModal.subtype"
    ></motor-decision-aid>

    <div class="container-x">
      <div id="motor-container" :class="device">

        <motor-display />
        <motor-recommendations @openModal="showPopup = true" :class="device" />

        <template v-if="device === 'mobile'">
          <sidebar :title="$t('powerpack.configurator.menu')">
            <motor-settings :class="device" />
          </sidebar>
        </template>
        <template v-else>
          <MotorSettings />
        </template>
      </div>
    </div>
    <popup-shopping-cart :generator="$t('cart.motor')" @close="showPopup = false" v-if="showPopup"></popup-shopping-cart>
  </div>

</template>

<script>
import {mapGetters, mapState} from 'vuex';
import MotorSettings from '@/components/motor/MotorSettings';
import MotorDisplay from '@/components/motor/MotorDisplay';
import MotorRecommendations from '@/components/motor/MotorRecommendations';
import PopupController from '@/components/hose/components/Popup';
import MotorDecisionAid from '@/components/motor/components/MotorDecisionAid';
import Sidebar from '@/components/sidebar/Sidebar';
import PopupShoppingCart from '@/components/popup/PopupShoppingCart';
import OrderCart from '@/components/step2/order/OrderCart.vue';
import { getBuildUidFromUrl } from '../../helpers/route';

export default {
  name: 'MotorConfigurator',
  components: {
    OrderCart,
    MotorDecisionAid,
    PopupController,
    MotorRecommendations,
    MotorDisplay,
    MotorSettings,
    Sidebar,
    PopupShoppingCart,
  },
  data() {
    return {
      showPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      preferences: 'build/motorConfig/getMotorPreferences',
      device: 'getDevice',
      openAid: 'preference/getModal',
      isMagento: 'preference/isMagento',
    }),
    ...mapState({
      isCartOpen: state => state.cart.isCartOpen,
    }),
    openModal: {
      get() {
        return this.openAid;
      },
      set(val) {
        this.$store.commit('preference/openAid', val);
      },
    },
  },

  methods: {
    setCartState() {
      if (this.isCartOpen) {
        this.$store.commit('cart/setCartState', false);
        return;
      }

      this.$store.commit('cart/setCartState', true);
    }
  },
  mounted() {
    const buildUid = getBuildUidFromUrl();

    if (!buildUid) {
      return;
    }

    this.$store.dispatch('build/motorConfig/fetchBuild', buildUid).then(build => {
      if (build) {
        this.$store.dispatch('build/motorConfig/loadBuild', build);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.motor-configurator {
  background-color: #F5F5F5;
  position: relative;
  overflow: auto !important;

  .view-cart-button {
    position: sticky;
    right: 0;
    top: -50px;
    left: 100%;
    z-index: 8;
    background: #FFFFFF;
    color: #71BC03;
    font-weight: 600;
    border: 2px solid #71BC03;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    margin-bottom: 20px;

    &:hover {
      background: rgba(#71BC03, 10%);
    }

    &:focus {
      outline: none;
    }
  }

  .cart-dropdown {
    z-index: 8;
    background: white;
    min-width: 420px;
    width: auto;
    position: absolute;
    top: 40px;
    right: 0;
    border-radius: 3px;
    padding: 20px;
    overflow: hidden;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .26) !important;

    @media only screen and (max-width: 512px) {
      right: 0;
      width: 100%;
      min-width: 100%;
    }
  }

  .sidebar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #3DB0C7;
    color: #fff;
    position: fixed;
    left: 0;
    top: 100px;
    padding: 0 15px;
    font-family: neue-haas-grotesk-text, sans-serif;
    font-size: 13px;
    transform-origin: top right;
    transform: translateX(-100%) rotate(270deg);
    height: 30px;
    line-height: 30px;
    width: 200px;
    transition: all .3s ease;
    z-index: 3;

    img {
      width: 15px;
      height: 15px;
    }

    &.open {
      left: 100%;
      transform: translateX(-100%) rotate(270deg) translateY(-100%);

      img {
        transform: rotate(180deg);
      }
    }
  }

  #motor-container {
    display: grid;
    grid-template-columns: 270px auto;
    grid-template-rows: auto auto auto;
    grid-gap: 15px;

    &.mobile {
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: auto auto auto;
      grid-gap: 0;
      max-width: 100%;
      margin-left: 25px;
    }
  }
}

.magento {
  .motor-configurator {
    padding-top: 0;
    background-color: #FFF;
  }
}
</style>
